export function CheckRow<T extends string>({
  options,
  values,
  onToggle,
  cols = 2,
}: {
  options: readonly { value: T; label: string }[];
  values: readonly T[];
  onToggle: (v: T) => void;
  cols?: 2 | 3;
}) {
  const gridClass =
    cols === 3
      ? "grid grid-cols-2 gap-2.5 sm:grid-cols-3"
      : "grid grid-cols-1 gap-2.5 sm:grid-cols-2";
  return (
    <div className={gridClass}>
      {options.map((opt) => {
        const checked = values.includes(opt.value);
        return (
          <label
            key={opt.value}
            className={`flex cursor-pointer items-center gap-2.5 rounded border px-3.5 py-3 text-sm transition ${
              checked
                ? "border-theme-accent bg-[#F9FBF4] text-ink"
                : "border-border bg-white text-ink-muted hover:border-ink-muted"
            }`}
          >
            <input
              type="checkbox"
              className="h-4 w-4 shrink-0 cursor-pointer accent-theme-accent"
              checked={checked}
              onChange={() => onToggle(opt.value)}
            />
            <span>{opt.label}</span>
          </label>
        );
      })}
    </div>
  );
}
